import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="docuseal"
export default class extends Controller {
  connect() {
    this.handleFormComplete = this.handleFormComplete.bind(this);
    window.docusealForm?.addEventListener("completed", this.handleFormComplete);
  }

  disconnect() {
    window.docusealForm?.removeEventListener(
      "completed",
      this.handleFormComplete,
    );
  }

  handleFormComplete(event) {
    this.dispatch("completed", { detail: event.detail });
  }
}
